var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"embed",class:{'compact':_vm.hasAddress},attrs:{"fluid":""}},[_c('EmbedSearch')],1)}
var staticRenderFns = []

export { render, staticRenderFns }